import { Suspense } from 'react';

import { AppLayout } from '@/components/layout/AppLayout';
import {
  ExpenseCreateSkeleton,
  ExpenseEditSkeleton,
} from '@/components/skeleton';

import { useSkeletonDebug } from '@/hooks/useSkeletonDebug';

import ExpenseForm from './ExpenseForm';

interface ExpenseFormWrapperProps {
  groupId: string;
  expenseId?: string;
  mode?: 'create' | 'edit';
}

function ExpenseFormContent({
  groupId,
  expenseId,
  mode = 'create',
}: ExpenseFormWrapperProps) {
  const { forceSkeleton } = useSkeletonDebug();

  if (forceSkeleton) {
    const SkeletonComponent =
      mode === 'edit' ? ExpenseEditSkeleton : ExpenseCreateSkeleton;
    return (
      <AppLayout>
        <SkeletonComponent />
      </AppLayout>
    );
  }

  return <ExpenseForm groupId={groupId} expenseId={expenseId} mode={mode} />;
}

export default function ExpenseFormWrapper(props: ExpenseFormWrapperProps) {
  const { mode = 'create' } = props;
  const SkeletonComponent =
    mode === 'edit' ? ExpenseEditSkeleton : ExpenseCreateSkeleton;

  return (
    <Suspense
      fallback={
        <AppLayout>
          <SkeletonComponent />
        </AppLayout>
      }
    >
      <ExpenseFormContent {...props} />
    </Suspense>
  );
}
